module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_5_52_3.2a541feb.png";